import { render, staticRenderFns } from "./VirtualizedSelect.vue?vue&type=template&id=c56b6c6a&scoped=true&"
import script from "./VirtualizedSelect.vue?vue&type=script&lang=js&"
export * from "./VirtualizedSelect.vue?vue&type=script&lang=js&"
import style0 from "./VirtualizedSelect.vue?vue&type=style&index=0&id=c56b6c6a&prod&lang=scss&scoped=true&"
import style1 from "./VirtualizedSelect.vue?vue&type=style&index=1&id=c56b6c6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56b6c6a",
  null
  
)

export default component.exports